import React from 'react';
import { useSelector } from 'react-redux';

function Spinner() {
  const spinner = useSelector((state) => state.spinner);
  if (!spinner) return '';
  return (
    <div className="spinner-canvas">
      <div className="triple-spinner"></div>
      <p className="spinner-info">{spinner.text}</p>
    </div>
  )
}

export default Spinner;